import { Directive, Input, ElementRef } from '@angular/core'

@Directive({ selector: '[extradata]' })
export class ExtraDataDirective {
  constructor(private el: ElementRef) {}

  @Input('extradata') set extradata(data: string) {
    const ele = this.el.nativeElement
    const info = ele.getAttribute('extradata')?.trim()
    info == '' && ele.setAttribute('extradata', data)
  }
}
